
import { Injectable, inject, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private doc = inject(DOCUMENT);
  private r = inject(RendererFactory2).createRenderer(null, null);
  private key = 'ui:theme';

  init(defaultTheme: Theme, opts: { respectSaved?: boolean } = { respectSaved: true }) {
    console.log(defaultTheme)
    const saved = localStorage.getItem(this.key) as Theme | null;
    const theme = opts.respectSaved && saved ? saved : defaultTheme;
    this.apply(theme);
  }

  apply(t: Theme) {
    localStorage.setItem(this.key, t);
    this.r.setAttribute(this.doc.documentElement, 'data-theme', t);
  }

  getTheme(): Theme { return (localStorage.getItem(this.key) as Theme) || 'light'; }
  setTheme(t: Theme) { this.apply(t); }
}
